// import consts from "@/consts.js";
import Request from './request';

import consts from "@/consts.js";


async function fetch(data) {
    return Request('get', "api/announcements/index", data);
}

// 显示隐藏
async function showHide(id){
    return Request('get',"api/announcements/hide/" + id )
}

async function top(id){
    return Request('get',"api/announcements/top/" + id )
}

async function del(id){
    return Request('delete',"api/announcements/del/" + id )
}

async function add(data){
    return Request('patch',"api/announcements/add/" ,data )
}

async function fetchOne(id){
    return Request('get',"api/announcements/view/" + id)
}

async function pushShop(data){
    return Request('patch',"api/announcements/pushShop/",data)
} 

async function accountAds(id){
    return Request('patch',"api/account-ads/view/" + id)
} 


async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; // 获取全部
    data.itemsPerPage = consts.limitAll // 获取全部
    // data.fieldFilter = ["id", "shop_code", "shop_name"]; //仅筛选少许必要字段
    return Request('get', "api/shops/select", data, false, false, true);
}

export default {
    fetch, 
    fetchOne,
    showHide,
    top,
    del,
    add,
    pushShop,
    fetchAllForSelect,
    accountAds
};